import mediator from "@tvg/mediator";

export const sendScrollEvent = (scrolledBack: boolean) => {
  mediator.base.dispatch({
    type: "TOP_POOLS_SCROLL_INTERACTION",
    payload: scrolledBack ? "Left" : "Right"
  });
};
